import { useState } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import Paywall from '@features/Paywall';
import PageContainer from '@components/Layout/PageContainer';
import { NavTabs } from '@components/NavTabs';
import { useTranslation } from '@hooks';
import { RoutePath } from '@constants/routes';
import { childRoutePath } from '@helpers/navigation';
import { BILLING_TYPE_MAP } from '@constants/billing';
import ReplyTemplates from './ReplyTemplates';
import AutoReplies from './AutoReplies';
import { getPlanName } from '@helpers/billing';

const ReplyAutomation = () => {
    const { pathname } = useLocation();
    const [currentTab, setCurrentTab] = useState(pathname);
    const { t } = useTranslation();

    const account = useSelector(state => state.account?.account);
    const isFreemiumPlan = getPlanName(account) === BILLING_TYPE_MAP.FREEMIUM;

    const availableTabs = [
        { label: t('Sidebar.reviewsAutoreplies'), value: RoutePath.ReviewsAutomationAutoReplies },
        { label: t('Sidebar.reviewsTemplates'), value: RoutePath.ReviewsAutomationTemplates },
    ];

    const RouteMap = {
        [RoutePath.ReviewsAutomationAutoReplies]: 0,
        [RoutePath.ReviewsAutomationTemplates]: 1,
    };

    return (
        <PageContainer>
            {isFreemiumPlan ? (
                <Paywall defaultPlan={BILLING_TYPE_MAP.STARTER} />
            ) : (
                <>
                    <NavTabs
                        tabLinks={availableTabs}
                        onTabClick={selectedTab => setCurrentTab(selectedTab)}
                        currentTabIndex={RouteMap[currentTab]}
                    />
                    <Routes>
                        <Route
                            path={childRoutePath(RoutePath.ReviewsAutomationTemplates, RoutePath.ReviewsAutomation)}
                            element={<ReplyTemplates />}
                        />
                        <Route
                            path={childRoutePath(RoutePath.ReviewsAutomationAutoReplies, RoutePath.ReviewsAutomation)}
                            element={<AutoReplies />}
                        />
                        <Route path="*" element={<Navigate to={RoutePath.ReviewsAutomationAutoReplies} replace />} />
                    </Routes>
                </>
            )}
        </PageContainer>
    );
};

export default ReplyAutomation;
